import { Circle } from "@mui/icons-material";
import {
  Box,
  Container,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { members, productId } from "../../constants/constants";
import "./team.scss";
import { getGenerationalConsultants } from "../../services/team/TeamServices";
import { BASE_URL, VDS_KEY, VERSION } from "../../constants/ApiUrls";
const Team = () => {
  const { t } = useTranslation();
  const [consultantsList, setConsultantList] = useState([]);
  const style = {
    fontSize: "13px",
    wordWrap: "break-word",
  };
  useEffect(() => {
    getConsultants();
  }, []);
  const getConsultants = async () => {
    let branchInfo = JSON.parse(localStorage.getItem("branchInfo"));
    let payload = {
      pageNumber: 1,
      pageSize: 100,
      bankGroupId: branchInfo.bankGroupId,
      bankId: branchInfo.bankId,
      branchId: branchInfo.branchId,
      productId: productId,
    };
    let apiResult = await getGenerationalConsultants(payload);
    setConsultantList(apiResult?.payLoad?.items);
  };
  return (
    <>
      <Container maxWidth="lg" className="team">
        <Grid container alignItems="center" height="95vh" className="showcase">
          <Grid item>
            <Typography variant="h4" width="50%" className="heading">
              {t("always-support")}
            </Typography>
          </Grid>
        </Grid>
        {consultantsList.map((item) => (
          <Grid
            container
            spacing={3}
            marginBottom={7}
            className="member"
            key={item.id}
            justifyContent="center"
          >
            <Grid
              item
              lg={2}
              md={2}
              sm={2}
              xs={12}
              className="user-image"
              marginTop="0.5rem"
            >
              {item?.consultantProfileImage ? (
                <Box
                  component="img"
                  src={
                    BASE_URL +
                    VDS_KEY +
                    VERSION +
                    "consultant/profile-picture?profilePicturePath=" +
                    item?.consultantProfileImage
                  }
                  width="100%"
                />
              ) : (
                <Box
                  component="div"
                  className="image"
                  borderRadius={4}
                  borderColor="color.magentaDark1"
                  border={1}
                  minHeight="170px"
                  width="80%"
                  marginLeft="0.5rem"
                />
              )}
            </Grid>
            <Grid
              item
              lg={7}
              md={7}
              sm={7}
              xs={12}
              className="user-profile-data"
              marginTop="0.5rem"
            >
              <Typography
                marginTop="2rem"
                sx={{ fontWeight: "bold" }}
                variant="inherit"
              >
                {item?.firstName + " " + item?.lastName}
              </Typography>
              <Typography
                style={{ wordWrap: "break-word" }}
                wordWrap="break-word"
                variant="body2"
                fontSize="12px"
                marginTop="0.5rem"
                marginRight="0.5rem"
              >
                {item?.description}
              </Typography>
            </Grid>
            <Grid
              item
              lg={3}
              md={3}
              sm={3}
              xs={12}
              className="user-roles"
              bgcolor="color.lightGrey"
              borderRadius={4}
              padding={2}
              marginTop="0.5rem"
              boxShadow="rgba(149, 157, 165, 0.2) 0px 8px 24px"
            >
              <Typography variant="inherit">Ausbildung</Typography>
              <Typography
                marginTop="0.5rem"
                marginLeft="1rem"
                variant="inherit"
              >
                <div
                  style={style}
                  dangerouslySetInnerHTML={{
                    __html: item?.education,
                  }}
                />
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Container>
    </>
  );
};

export default Team;
